import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		alignItems: 'center',
		margin: theme.spacing(2),
		'& > *': {
			color: theme.palette.background.paper,
		},
	},
	button: {
		marginRight: 4,
		background: 'none',
		color: 'inherit',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		outline: 'inherit',
		minWidth: 'initial',
	},
}));

export default useStyles;
